import { render, staticRenderFns } from "./BasicInformationAboutSubjectSearchSelectUnit.vue?vue&type=template&id=5f263b8e&"
import script from "./BasicInformationAboutSubjectSearchSelectUnit.vue?vue&type=script&lang=js&"
export * from "./BasicInformationAboutSubjectSearchSelectUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports